import React from 'react';

export default () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.4144 1.75813L14.2422 0.585938C13.8516 0.195312 13.3397 0 12.8278 0C12.316 0 11.8041 0.195312 11.4138 0.585625L9.08597 2.91344L8.00003 3.99938L0.401594 11.5975L0.00471869 15.1669C-0.0452813 15.6163 0.308781 16 0.748469 16C0.776281 16 0.804406 15.9984 0.832531 15.9953L4.39941 15.6012L12.0007 8L13.0863 6.91437L15.4141 4.58656C16.1953 3.80531 16.1953 2.53906 15.4144 1.75813ZM3.71097 14.1684L1.59909 14.4016L1.83441 12.2863L9.06066 5.06L10.03 4.09062L11.9094 5.97L10.94 6.93937L3.71097 14.1684ZM14.3535 3.52563L12.9697 4.90938L11.0907 3.03L12.4744 1.64625C12.6019 1.51875 12.7507 1.49969 12.8278 1.49969C12.905 1.49969 13.0541 1.51875 13.1813 1.64625L14.3535 2.81844C14.5485 3.01375 14.5485 3.33094 14.3535 3.52563Z'
      fill='#008ED1'
    />
  </svg>
);
